type Props = { fill?: string; size?: number };

const CheckSingleIcon = ({ fill = "#3B3F42", size = 12 }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_13033_63777)">
        <path
          d="M4.49945 11.2499C4.30055 11.2498 4.10982 11.1708 3.9692 11.0301L0.219201 7.28013C0.147568 7.21094 0.0904312 7.12819 0.0511245 7.03668C0.0118177 6.94518 -0.00887195 6.84676 -0.00973731 6.74718C-0.0106027 6.6476 0.00837361 6.54884 0.0460843 6.45666C0.0837949 6.36449 0.139485 6.28075 0.209904 6.21033C0.280324 6.13991 0.364063 6.08422 0.456235 6.04651C0.548407 6.0088 0.647167 5.98983 0.746751 5.99069C0.846336 5.99156 0.944751 6.01225 1.03625 6.05155C1.12776 6.09086 1.21052 6.148 1.2797 6.21963L4.39445 9.33363L10.633 0.323129C10.6879 0.239607 10.759 0.167913 10.8421 0.112266C10.9251 0.0566177 11.0185 0.0181382 11.1166 -0.000910172C11.2148 -0.0199586 11.3157 -0.0191915 11.4136 0.00134603C11.5114 0.0218835 11.6042 0.0617769 11.6864 0.11868C11.7686 0.175584 11.8386 0.248349 11.8923 0.332697C11.9459 0.417045 11.9822 0.511274 11.9989 0.609843C12.0157 0.708411 12.0125 0.80933 11.9897 0.906665C11.9668 1.004 11.9248 1.09579 11.8659 1.17663L5.11595 10.9266C5.05378 11.0175 4.97236 11.0936 4.87748 11.1494C4.7826 11.2053 4.67658 11.2396 4.56695 11.2499C4.54445 11.2499 4.52195 11.2499 4.49945 11.2499Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default CheckSingleIcon;
